'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import ErrorBoundary from '@haaretz/s-error-boundary';
import HtzLink from '@haaretz/s-htz-link';
import useBi from '@haaretz/s-use-bi';
import * as React from 'react';
function BreadcrumbClient({ href, children }) {
    const biAction = useBi();
    const breadcrumbOnclick = ()=>{
        biAction({
            feature_type: 'content',
            feature: 'breadcrumbs',
            campaign_details: children,
            action_id: 153
        });
    };
    return /*#__PURE__*/ _jsx(HtzLink, {
        href: href,
        onClick: breadcrumbOnclick,
        "data-testid": "breadcrumb-link",
        children: children
    });
}
export default function BreadcrumbClientWrapper({ children, ...props }) {
    return /*#__PURE__*/ _jsx(ErrorBoundary, {
        children: /*#__PURE__*/ _jsx(BreadcrumbClient, {
            ...props,
            children: children
        })
    });
}

//# sourceMappingURL=Breadcrumb.client.js.map